import React, { useState } from "react";
import styled from "styled-components";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import dayjs, { ManipulateType } from "dayjs";
import { TransparentOverlay } from "../Filters/RangeModal";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

interface SCalendarModalContainer {
  sPosition?: string;
  sMarginTop?: number;
  sMarginLeft?: string;
}

interface CalendarModalProps extends SCalendarModalContainer {
  closeEvent: () => void;
  changeEvent: (date: string) => void;
  dateValue?: string;
  isAllSelectable?: boolean;
  isFutureDisable?: boolean;
  isAfterStartDate?: boolean;
  isFutureDisableFromToday?: boolean;
  isTodayDisable?: boolean;
  isAfter?: {
    value: number;
    unit: string;
  };
  indefiniteOption?: {
    enabled: boolean;
    label?: string;
    value?: string;
  };
  minDate?: string;
  maxDate?: string;
}

dayjs.extend(isSameOrAfter); // 플러그인 등록
dayjs.locale("ko"); // 언어 등록

export default function CalendarModal({
  closeEvent,
  changeEvent,
  sPosition,
  sMarginTop,
  sMarginLeft,
  dateValue,
  isAllSelectable,
  isFutureDisable,
  isAfterStartDate,
  isFutureDisableFromToday,
  isTodayDisable,
  isAfter,
  indefiniteOption,
  minDate,
  maxDate,
}: CalendarModalProps) {
  console.log("open");

  console.log(dateValue);

  const year = Number(dateValue?.split("-")[0]);
  const month = Number(dateValue?.split("-")[1]) - 1;
  const day = Number(dateValue?.split("-")[2]);

  const defaultStartDate = dateValue ? new Date(year, month, day) : new Date();

  const [value, setValue] = useState(defaultStartDate);

  // react-calendar 네이티브 제한을 위한 Date 변환
  const nativeMinDate = minDate ? new Date(minDate) : undefined;
  const nativeMaxDate = maxDate ? new Date(maxDate) : undefined;

  return (
    <>
      <CalendarModalContainer
        sPosition={sPosition}
        sMarginTop={sMarginTop}
        sMarginLeft={sMarginLeft}
      >
        <StyledCalendar
          value={value}
          onChange={(date: any) => {
            setValue(date);
            changeEvent(dayjs(date)?.format("YYYY-MM-DD"));
            closeEvent();
          }}
          formatDay={(locale, date) => dayjs(date).format("D")}
          calendarType="US"
          prevLabel={
            <PrevIcon className="material-icons-outlined">
              chevron_left
            </PrevIcon>
          }
          nextLabel={
            <PrevIcon className="material-icons-outlined">
              chevron_right
            </PrevIcon>
          }
          prev2Label={null}
          next2Label={null}
          locale="ko"
          defaultActiveStartDate={defaultStartDate}
          minDate={nativeMinDate}
          maxDate={nativeMaxDate}
          tileDisabled={({ activeStartDate, date, view }) => {
            if (minDate || maxDate) {
              const d = dayjs(date);
              if (minDate && d.isBefore(dayjs(minDate), "day")) return true;
              if (maxDate && d.isAfter(dayjs(maxDate), "day")) return true;
              return false;
            } else if (isAllSelectable) {
              return false;
            } else if (isAfterStartDate) {
              console.log(defaultStartDate);

              return (
                !dayjs().isAfter(dayjs(date)) ||
                dayjs(date).isBefore(
                  dayjs(defaultStartDate.setHours(0, 0, 0, 0))
                )
              );
            } else if (isAfter) {
              return (
                (isTodayDisable
                  ? !dayjs().add(-1, "day").isAfter(dayjs(date))
                  : !dayjs().isAfter(dayjs(date))) ||
                dayjs(date).isSameOrAfter(
                  dayjs(defaultStartDate).add(
                    isAfter.value,
                    isAfter.unit as ManipulateType
                  )
                ) ||
                dayjs(date).isBefore(
                  dayjs(defaultStartDate.setHours(0, 0, 0, 0))
                )
              );
            } else if (isFutureDisable) {
              return dayjs(date).isAfter(
                dayjs(defaultStartDate.setHours(0, 0, 0, 0))
              );
            } else if (isFutureDisableFromToday) {
              return dayjs(date).isSameOrAfter(
                dayjs(defaultStartDate.setHours(0, 0, 0, 0))
              );
            } else {
              return dayjs(date).isBefore(
                dayjs(defaultStartDate.setHours(0, 0, 0, 0))
              );
            }
          }}
        />

        {indefiniteOption?.enabled && (
          <IndefiniteButton
            onClick={() => {
              changeEvent(indefiniteOption?.value ?? "9999-12-31");
              closeEvent();
            }}
          >
            {indefiniteOption?.label ?? "무기한"}
          </IndefiniteButton>
        )}
      </CalendarModalContainer>

      <TransparentOverlay onClick={() => closeEvent()} />
    </>
  );
}

const CalendarModalContainer = styled.div<SCalendarModalContainer>`
  position: ${({ sPosition }) => sPosition ?? "fixed"};
  margin-top: ${({ sMarginTop }) => sMarginTop ?? 10}px;
  margin-left: ${({ sMarginLeft }) => sMarginLeft ?? "unset"};
  border-radius: 10px;
  box-shadow: 0 5px 16px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 20px;
  min-height: 284px;
  z-index: 10;

  .react-calendar {
    width: 248px !important;
    border: none !important;
    font-family: -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo",
      Pretendard Variable, Roboto, "Noto Sans KR", "Segoe UI", "Malgun Gothic",
      sans-serif;
  }
`;

const StyledCalendar = styled(Calendar)`
  .react-calendar__navigation {
    height: 24px;
    margin-bottom: 8px;
  }

  abbr[title] {
    text-decoration: none;
  }

  .react-calendar__tile {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    padding: unset;
    display: flex;
    align-items: center;
    justify-content: center;

    abbr {
      font-size: 13px;
      font-weight: 500;
      line-height: 19.5px;
      text-align: center;
      color: #505050;
    }

    .react-calendar__tile
      react-calendar__month-view__days__day
      react-calendar__month-view__days__day--weekend
      react-calendar__month-view__days__day--neighboringMonth
      &:nth-child(7n + 1) {
      abbr {
        color: #d3d3d3;
      }
    }

    &:disabled {
      background-color: inherit;

      abbr {
        color: #d3d3d3 !important;
      }

      &:hover {
        background-color: ${({ theme }) => theme.color.white} !important;
      }
    }
  }

  .react-calendar__tile--active {
    background-color: ${({ theme }) => theme.buttonColor.blueNormal};

    abbr {
      color: white;
    }
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: ${({ theme }) => theme.buttonColor.whiteHover};
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background-color: ${({ theme }) => theme.buttonColor.blueHover};
  }

  .react-calendar__tile react-calendar__month-view__days__day {
    flex: unset;
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: unset;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    abbr {
      font-size: 13px;
      font-weight: 500;
      line-height: 19.5px;
      text-align: center;
      color: #858c97;
    }
  }

  .react-calendar__navigation button {
    min-width: 24px;
    border-radius: 5px;
    padding: 0;

    &:hover {
      background-color: ${({ theme }) => theme.buttonColor.whiteHover};
    }
  }

  .react-calendar__navigation__label {
    span {
      font-size: 15px;
      font-weight: bold;
      line-height: 22.5px;
      text-align: left;
      color: #606060;
    }
  }

  .react-calendar__tile--now {
    background: white;

    abbr {
      color: #505050 !important;
    }

    &:hover {
      background-color: ${({ theme }) =>
        theme.buttonColor.whiteHover} !important;
    }
  }

  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    grid-gap: 4px;
  }
`;

const PrevIcon = styled.span`
  font-size: 24px;
  color: #858c97;
`;

const IndefiniteButton = styled.button`
  width: 100%;
  height: 38px;
  margin-top: 12px;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  color: #505050;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`;
